if(!document.body.classList.contains('product-custom-bundle')){
  /*Draggable */
  gsap?.registerPlugin(Draggable);
}

function height_head(e) {
  var top_height = $(
      ".shopify-section-group-header-group.index-section--flush"
    ),
    header_height = $(".section-header");

  top_height.css("--top_height", top_height.height());
  header_height.css("--head_height", header_height.height());
}

$(document).resize(function () {
  height_head();
});
$(document).ready(function () {
  height_head();

  //Redirect to PDP when variant has redirect URL on PDP
  $("body").on("click", ".variant-input:not(.sold-out)", function (e) {
    var selected_val = $(this).attr("data-redirect_url");
    if (
      selected_val != "false" &&
      $(e.target).parents(".accordion--content").length == 0
    ) {
      // console.log(selected_val, typeof selected_val);
      window.location.href = selected_val;
    }
  });
  
  // var ele = $('.home_slider');
  // var home_hero_slider = ele.slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   dots: false,
  //   infinite: true,
  //   swipe: true,
  //   arrows: false
  // });
  
  
  // $("body").on("click", "li.childmenu-item.has-submenu", function (e) {
  //   e.preventDefault();
  //   var submenuHandle = $(this).attr("data-submenu");
  //   var grandSubMenuMobile = $(this).find(
  //     `ul.grandchild-menu-inner.mobile-submenu[data-submenu="${submenuHandle}"]`
  //   );
  //   console.log('grandSubMenuMobile',grandSubMenuMobile)

  //   // Check if the clicked menu is already active
  //   if ($(this).hasClass("active")) {
  //     // If it's active, close the submenu and remove 'active' class
  //     $(this).removeClass("active");
  //     grandSubMenuMobile.stop(true, true).slideUp("slow");
  //   } else {
  //     // Close all other submenus and remove 'active' class from other items
  //     $("li.childmenu-item.has-submenu").removeClass("active");
  //     $("ul.grandchild-menu-inner.mobile-submenu").slideUp("slow");

  //     // Open the clicked submenu and add 'active' class
  //     $(this).addClass("active");
  //     grandSubMenuMobile.stop(true, true).slideDown("slow");
  //   }

  //   // Toggle the class on the body element for the drawer
  //   document.body.classList.toggle(
  //     "sbmenu-drawer-open",
  //     $("li.childmenu-item.has-submenu.active").length > 0
  //   );
  // });


  /*Udpated mobile menu click code*/
  // Handler for the main menu item with a submenu
  
$("body").on("click", "div.childmenu-item.has-submenu .js-toggleMenuBtn", function (e) {
  // console.log(e.target)
    e.stopPropagation(); 
    e.preventDefault();
    var parent = $(this).parent('[data-submenu]');
    var submenuHandle = parent.attr("data-submenu");
    var grandSubMenuMobile = parent.find(`ul.grandchild-menu-inner.mobile-submenu[data-submenu="${submenuHandle}"]`);
    
    // Check if the clicked menu is already active
    if (parent.hasClass("active")) {
        // If it's active, close the submenu and remove 'active' class
        parent.removeClass("active");
        grandSubMenuMobile.stop(true, true).slideUp("slow");
    } else {
        // Close all other submenus and remove 'active' class from other items
          $("div.childmenu-item.has-submenu").removeClass("active");
        $("ul.grandchild-menu-inner.mobile-submenu").slideUp("slow");

        // Open the clicked submenu and add 'active' class
        parent.addClass("active");
        grandSubMenuMobile.stop(true, true).slideDown("slow");
    }

    // Toggle the class on the body element for the drawer
    // document.body.classList.toggle("sbmenu-drawer-open", $("li.childmenu-item.has-submenu.active").length > 0);
  
});

// Prevent event propagation for submenu links
$("body").on("click", "ul.grandchild-menu-inner.mobile-submenu a", function(e) {
    // e.stopPropagation(); // Prevent the click from bubbling up to parent li
});



  var home_featured_ele = $(".collection_view-slider .featured-slider");
  home_featured_ele.each((i, item) => {
    var parent = $(item).parents(".featured-colllection-custom"),
      next_btn = parent.find(".next-btn"),
      prev_btn = parent.find(".prev-btn");
    var ele = home_featured_ele[0];
    var swiper = new Swiper(ele, {
      slidesPerView: "auto",
      freeMode: false,
      centerInsufficientSlides: true,
      initialSlide: 2,
      grabCursor: true,
      // slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: next_btn[0],
        prevEl: prev_btn[0],
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetweenSlides: 30,
        },
        769: {
          slidesPerView: 1.7,
          spaceBetweenSlides: 0,
        },
        280: {
          slidesPerView: 1,
          spaceBetweenSlides: 20,
        },
      },
    });
  });

  //TEstimonial slider
  if (document.querySelector(".testi_slider")) {
    var hasNextPrev = document.querySelector(".testi_slider").getAttribute("data-nextprev");
    if (hasNextPrev) {
      var swiper = new Swiper(".testi_slider", {
        autoHeight: false,
        effect: "fade",
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn",
        },
      });
    } else {
      var swiper = new Swiper(".testi_slider", {
        autoHeight: false,
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
      });
    }
  }
  //parallax images
  if (window.simpleParallaxItems) {
    for (let index = 0; index < window.simpleParallaxItems.length; index++) {
      const item = window.simpleParallaxItems[index];
      var image0 = document.querySelector(`${item.element}`);
      var config = item.config;
      // console.log('image',image,`${item.element}`)
      if (image0) {
        new SimpleParallax(image0, config);
        // var parallax = new SimpleParallax({
        //     element: image0
        //   });
      }
    }
  }

  $(".custom-klaviyo-button").on("click", function (e) {
    e.preventDefault();
    if(document.querySelector(".klaviyo-bis-trigger")){
    document.querySelector(".klaviyo-bis-trigger").click();
    }
  });

  if (window.innerWidth >= 576 && window.innerWidth <= 768) {
    var swiper = new Swiper(".grid_banner_inner", {
      spaceBetween: 15,
      slidesPerView: 2.3,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  if (window.innerWidth <= 575) {
    var swiper = new Swiper(".grid_banner_inner", {
      spaceBetween: 15,
      slidesPerView: 1.3,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

if(!document.body.classList.contains('product-custom-bundle')){
  //Animated icons
  if (window.theme.animated_icons) {
    // console.log("window.theme.animated_icons", window.theme.animated_icons);
    /*Working code*/
    // for (let index = 0; index < window.theme.animated_icons.length; index++) {
    //   const item = window.theme.animated_icons[index],
    //     sectionId = item.sectionId;
    //   const element = document.querySelector(`#${sectionId} ${item.element}`);
    //   if (item.hasSVGFile==false) {
    //     if (element) {
    //       console.log("element", element);
    //       element.innerHTML = item.text
    //         .split("")
    //         .map((char, i) => {
    //           if (char == "#") {
    //             return `<span class="icon-separator" style="transform:rotate(${
    //               i * 10.3
    //             }deg)">${char}</span>`;
    //           } else {
    //             return `<span class="icon-text" style="transform:rotate(${
    //               i * 10.5
    //             }deg)">${char}</span>`;
    //           }
    //         })
    //         .join("");
    //     }
    //   } else {
    //     var ele = element;
    //     console.log('item.svgFile',item.svgFile)
    //     fetch(item.svgFile)
    //       .then((response) => response.text())
    //       .then((svg) => {
    //         ele.innerHTML = svg;
    //       });
    //   }
    //   element.classList.add("visible");
    // }

    const fetchPromises = [];

    for (let index = 0; index < window.theme.animated_icons.length; index++) {
      const item = window.theme.animated_icons[index],
        sectionId = item.sectionId;
      const element = document.querySelector(`#${sectionId} ${item.element}`);

      if (element) {
        if (!item.hasSVGFile) {
          // console.log("element", element);
          element.innerHTML = item.text
            .split("")
            .map((char, i) => {
              if (char === "#") {
                return `<span class="icon-separator" style="transform:rotate(${
                  i * 10.3
                }deg)">${char}</span>`;
              } else {
                return `<span class="icon-text" style="transform:rotate(${
                  i * 10.5
                }deg)">${char}</span>`;
              }
            })
            .join("");
        } else {
          // console.log("item.svgFile", item.svgFile);
          // Store fetch promises in an array
          const fetchPromise = fetch(item.svgFile)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.text();
            })
            .then((svg) => {
              return { element, svg }; // Return both element and svg for later use
            })
            .catch((error) => {
              console.error(
                "There was a problem with the fetch operation:",
                error
              );
            });

          fetchPromises.push(fetchPromise);
        }
      }
    }

    // After all fetch requests are completed
    Promise.all(fetchPromises).then((results) => {
      results.forEach(({ element, svg }) => {
        element.innerHTML = svg;
        element.classList.add("visible");
      });
    });

    for (let index = 0; index < window.theme.animated_icons.length; index++) {
      const item = window.theme.animated_icons[index],
        sectionId = item.sectionId;
      if (item.x) {
        gsap.set(`#${sectionId}`, { x: `${item.x}%`, y: `${item.y}px` });
      }
    }
    // Make the .draggable-item draggable within its wrapper
    Draggable.create(".draggable-item", {
      type: "x,y",
      bounds: ".foo_animation",
      edgeResistance: 0.65,
      inertia: true,
      cursor: "grab",
      onPress: function () {
        this.target.style.cursor = "grabbing";
      },
      onRelease: function () {
        this.target.style.cursor = "grab";
      },
      onDrag: function () {
        // Optional: Add any logic you want to perform during dragging
      },
    });
  }
}

  //blog post tabs
  var tabList = document.querySelector(".tabs_heading");
  if (tabList) {
    tabListLink = document.querySelectorAll(".tabs_heading li a");
    tabListLink.forEach((ele) => {
      ele.addEventListener("click", function (e) {
        // console.log(e.target)
        var title = e.target.innerText;
        document.querySelector(
          ".featured-blog-custom .comn_heading.title"
        ).innerText = title;
        document
          .querySelectorAll(".tabs_heading li")
          .forEach((ele) => ele.classList.remove("active"));
        e.target.parentNode.classList.add("active");
        var blog = e.target.getAttribute("data-blog");
        var tabContent = document.querySelector(
          `.blog-tab-content[data-blog="${blog}"]`
        );
        // console.log(document.querySelector(`.blog-tab-content:not([data-blog = "${blog}"])`))
        document
          .querySelectorAll(`.blog-tab-content:not([data-blog = "${blog}"])`)
          .forEach((ele) => ele.classList.remove("active"));
        if (tabContent) {
          tabContent.classList.add("active");
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
 
  /*Enlarge text on hover for HP and PDP*/
  // document.querySelectorAll('.hovered_main .text_wraps span').forEach(function(span) {
  //      const hoverTxt = span.querySelector('.hover_txt');

  //      // // On mouse enter, add scale-up animation
  //      // span.addEventListener('mouseenter', function() {
  //      //     hoverTxt.style.transform = 'scale(1.3)'; // Enlarge the text
  //      //     hoverTxt.style.opacity = '1'; // Make it visible
  //      // //     // hoverTxt.style.transition = 'transform 0.4s ease, opacity 0.4s ease'; // Smooth transition
  //      // });

  //      // On mouse move, add slight trailing effect
  //      span.addEventListener('mousemove', function(event) {
  //          const rect = span.getBoundingClientRect();
  //          const mouseX = event.clientX - rect.left - rect.width / 2;
  //          const mouseY = event.clientY - rect.top - rect.height / 2;

  //          // Add slight trailing effect on hover
  //          hoverTxt.style.transform = `translate(${mouseX * 0.1}px, ${mouseY * 0.1}px) scale(1.3)`;
  //      });

  //      // On mouse leave, reset the scale and opacity
  //      span.addEventListener('mouseleave', function() {
  //          hoverTxt.style.transform = 'scale(0)'; // Scale down the text
  //          // hoverTxt.style.opacity = '0'; // Hide it
  //          // hoverTxt.removeAttribute('style'); // Remove all inline styles to reset completely
  //      });
  //  });

  // document.querySelectorAll('.hovered_main .text_wraps span').forEach(function(span) {
  //     const hoverTxt = span.querySelector('.hover_txt');

  //     span.addEventListener('mousemove', function(event) {
  //         const rect = span.getBoundingClientRect();
  //         const mouseX = event.clientX - rect.left;
  //         const mouseY = event.clientY - rect.top;

  //         // Add a slight trailing effect by adjusting the transform
  //         hoverTxt.style.transform = `translate(${(mouseX - rect.width / 2) * 0.1}px, ${(mouseY - rect.height / 2) * 0.1}px) scale(1.1)`;
  //         hoverTxt.style.transition = 'transform 0.3s ease-out';
  //     });

  //     // Reset the hover text on mouse leave
  //     span.addEventListener('mouseleave', function() {
  //         hoverTxt.style.transform = 'scale(0)'; // Reset to original position
  //         hoverTxt.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
  //     });
  // });

  // sagar js start
  $("body").on("click", ".js-custom-shoppay-trigger", function () {
    if ($("shopify-payment-terms")[0].shadowRoot) {
      $($("shopify-payment-terms")[0].shadowRoot)
        .find("button")
        .trigger("click");
    }
  });

  /*FAQ scorlll to section JS*/
  if (document.querySelector(".faq-categories")) {
    document
      .querySelector(".faq-categories")
      .addEventListener("change", function () {
        const selectedValue = this.value;

        if (selectedValue) {
          // Find the section with the corresponding id
          const targetSection = document.querySelector(
            `.section--faq-group-heading[id="${selectedValue}"]`
          );
          // console.log('targetSection',targetSection)

          if (targetSection) {
            // Get the offset position of the section minus 150px
            const targetPosition =
              targetSection.getBoundingClientRect().top +
              window.pageYOffset -
              150;

            // Scroll to the calculated position smoothly
            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
          }
        }
      });
  }

  const sepTitles = document.querySelectorAll("[data-tooltip]");
  const tooltip = document.getElementById("ingredient-tooltip");

  sepTitles.forEach((sepTitle) => {
    var cont = sepTitle.getAttribute("data-tooltip");
    tippy(sepTitle, {
      content: cont,
      // animation: "scale",
      allowHTML: true,
      arrow: true,
      theme: 'light',
    });
    // sepTitle.addEventListener("mousemove", (e) => {
    //   // Set the HTML content of the tooltip from the data-tooltip attribute
    //   tooltip.innerHTML = sepTitle.getAttribute("data-tooltip");

    //   const tooltipWidth = tooltip.offsetWidth;
    //   const tooltipHeight = tooltip.offsetHeight;
    //   const pageWidth = window.innerWidth;
    //   const pageHeight = window.innerHeight;
    //   const cursorOffset = 15; // Offset between the cursor and the tooltip

    //   let leftPosition = e.clientX;
    //   let topPosition = e.clientY;

    //   // Apply the calculated positions to the tooltip
    //   tooltip.style.left = `${leftPosition}px`;
    //   tooltip.style.top = `${topPosition}px`;

    //   // Make the tooltip visible
    //   tooltip.style.opacity = 1;
    // });

    // sepTitle.addEventListener("mouseleave", () => {
    //   // Hide the tooltip when not hovering
    //   tooltip.style.opacity = 0;
    // });
  });

  // Select elements
  var nutrientPopUp = document.getElementById("mobile-nutrient-pop-up");
  if (nutrientPopUp) {
    var nutrientPopUpContent = document.getElementById(
      "nutrient-pop-up-content"
    );
    var nutrientPopUpClose = nutrientPopUp.querySelector(".popup_close");
    var html = document.documentElement; // Selects the <html> element

    // Event listener for click on elements with the class "sep_title"
    // document.body.addEventListener("click", function (event) {
    //   if (event.target.classList.contains("sep_title")) {
    //     var _this = event.target;
    //     console.log("_this", _this, nutrientPopUpContent);
    //     nutrientPopUpContent.innerHTML = _this.getAttribute("data-tooltip");
    //     html.classList.add("nutrient_pop_up_active");
    //   }
    // });

    // Event listener for closing the popup
    // nutrientPopUpClose.addEventListener("click", function () {
    //   html.classList.remove("nutrient_pop_up_active");
    //   nutrientPopUpContent.innerHTML = ""; // Clear the content
    // });
  }
}) /* DOM contentLoaded ends here */;

// Get elements
if(window.innerWidth < 1024){
 var triggerBtn = document.getElementById("mobile-trigger-btn");
}else{
  var triggerBtn = document.getElementById("trigger-btn");
}

const popup = document.getElementById("nutritional-popup");
const closeBtn = document.querySelector(".close-btn");

if (popup) {
  $(window).resize( function(){
    if(window.innerWidth < 1024){
     var triggerBtn = document.getElementById("mobile-trigger-btn");
    }else{
      var triggerBtn = document.getElementById("trigger-btn");
    }
  })
  // Get elements
  if(window.innerWidth < 1024){
   var triggerBtn = document.getElementById("mobile-trigger-btn");
  }else{
    var triggerBtn = document.getElementById("trigger-btn");
  }
  const closeBtn = document.querySelector(".close-btn");
  const body = document.body;

  if (triggerBtn) {
    // Open popup by adding 'popup-active' class to body
    triggerBtn.addEventListener("click", () => {
      body.classList.add("popup-active");
    });
    // Close popup by removing 'popup-active' class from body
    closeBtn.addEventListener("click", () => {
      body.classList.remove("popup-active");
    });
  }

  // Optional: Close popup if clicking outside the popup content
  document
    .getElementById("nutritional-popup")
    .addEventListener("click", (e) => {
      if (e.target === document.getElementById("nutritional-popup")) {
        body.classList.remove("popup-active");
      }
    });
}
// sagar js start

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  // var id = event.data.variant.id.toString();
  // $('.pdp-descripton-icons .section_wrapper').empty().append($('.variant_data #variant-'+id))
  // console.log('variant_data',$('.variant_data #variant-'+id))
});

/*PDP ATC Bottom sticky */
window.addEventListener("scroll", function () {
  const stickyBar = document.getElementById("stickyBar");
  if (stickyBar) {
    // const wrapper = document.querySelector(".pdp_main");
    if(window.theme.is_rtd_template){
      var wrapper = document.querySelector(".pdp-descripton-icons");      
    }else{
      var wrapper = document.querySelector(".prod-qty-picker-atc-wrapper");
    }
    const wrapperRect = wrapper.getBoundingClientRect();
    // Check if the top of the wrapper is above the viewport
    if (wrapperRect.bottom < 0) {
      stickyBar.classList.add("atc-sticky");
    } else {
      stickyBar.classList.remove("atc-sticky");
    }
  }
});

var jsAtcBtn = document.querySelector(".js-sticky-atc"),
  prodformAtc = document.querySelector("button.product-form__submit");
if (jsAtcBtn && prodformAtc) {
  jsAtcBtn.addEventListener("click", () => {
    prodformAtc.click();
  });
}

/***********Hover texts JS starts**********/
// //Correct code here
// const hoverTexts = document.querySelectorAll(".hover-text");

// // Function to create a rectangular shape
// function createRectShape(text) {
//   const shape = document.createElement("div");
//   shape.classList.add("random-shape");
//   shape.innerText = text; // Set the same text on the shape
//   return shape;
// }

// // Function to adjust shape position for mobile
// function adjustShapePosition(shape, x, y) {
//   const viewportWidth = window.innerWidth;
//   const shapeWidth = shape.offsetWidth;
//   const shapeHeight = shape.offsetHeight;

//   // Center the shape if it exceeds viewport boundaries
//   if (x + shapeWidth / 2 > viewportWidth) {
//     x = viewportWidth - shapeWidth / 2; // Align to the right
//   } else if (x - shapeWidth / 2 < 0) {
//     x = shapeWidth / 2; // Align to the left
//   }

//   gsap.set(shape, {
//     x: x - shapeWidth / 2,
//     y: y - shapeHeight / 2,
//   });
// }

// // Hover Effect with slow trailing mouse movement
// hoverTexts.forEach((text) => {
//   let randomShape = null;

//   const handleMouseMove = (e) => {
//     if (!randomShape) return; // Check if randomShape exists before proceeding

//     const rect = text.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     const y = e.clientY - rect.top;

//     // Move the shape to follow the mouse slowly
//     adjustShapePosition(randomShape, x, y);
//     gsap.to(randomShape, {
//       duration: 0.2, // Adjust duration for a smooth effect
//       ease: "power2.out", // Smooth easing for the movement
//     });
//   };

//   const handleTouchStart = (e) => {
//     const touch = e.touches[0];
//     const rect = text.getBoundingClientRect();
//     const x = touch.clientX - rect.left;
//     const y = touch.clientY - rect.top;

//     // Create a new rectangular shape and append it
//     if (!randomShape) {
//       // Only create if it doesn't already exist
//       randomShape = createRectShape(text.innerText);
//       text.appendChild(randomShape);

//       // Initial animation to show shape
//       gsap.to(randomShape, {
//         opacity: 1,
//         scale: 2,
//         duration: 0.2, // Slightly slower scale-in effect
//         ease: "power2.out",
//       });

//       // Position the shape
//       adjustShapePosition(randomShape, x, y);

//       // Add touchmove event to move shape with slow and smooth effect
//       text.addEventListener("touchmove", handleMouseMove);
//     }
//   };

//   text.addEventListener("mouseenter", () => {
//     // Create a new rectangular shape and append it
//     if (!randomShape) {
//       // Only create if it doesn't already exist
//       randomShape = createRectShape(text.innerText);
//       text.appendChild(randomShape);

//       // Initial animation to show shape
//       gsap.to(randomShape, {
//         opacity: 1,
//         scale: 2,
//         duration: 0.2, // Slightly slower scale-in effect
//         ease: "power2.out",
//       });

//       // Add mousemove event to move shape with slow and smooth effect
//       text.addEventListener("mousemove", handleMouseMove);
//     }
//   });

//   // Remove the shape on mouse leave
//   text.addEventListener("mouseleave", () => {
//     if (randomShape) {
//       // Check if the shape exists
//       gsap.to(randomShape, {
//         opacity: 0,
//         scale: 0.5,
//         duration: 0.2, // Slightly slower disappearance effect
//         ease: "power2.out",
//         onComplete: () => {
//           if (text.contains(randomShape)) {
//             text.removeChild(randomShape);
//             randomShape = null; // Reset randomShape to allow recreation on next hover
//           }
//         },
//       });
//     }
//     // Remove the mousemove event listener to avoid duplicates
//     text.removeEventListener("mousemove", handleMouseMove);
//   });

//   // Add touchstart event for mobile
//   text.addEventListener("touchstart", handleTouchStart);
//   text.addEventListener("touchend", () => {
//     if (randomShape) {
//       gsap.to(randomShape, {
//         opacity: 0,
//         scale: 0.5,
//         duration: 0.2,
//         ease: "power2.out",
//         onComplete: () => {
//           if (text.contains(randomShape)) {
//             text.removeChild(randomShape);
//             randomShape = null; // Reset randomShape to allow recreation on next touch
//           }
//         },
//       });
//     }
//     // Remove the touchmove event listener
//     text.removeEventListener("touchmove", handleMouseMove);
//   });
// });


const hoverTexts = document.querySelectorAll(".hover-text");

// Function to create a rectangular shape
function createRectShape(text) {
  const shape = document.createElement("div");
  shape.classList.add("random-shape");
  shape.innerText = text; // Set the same text on the shape
  shape.style.opacity = 0; // Start with opacity 0
  shape.style.position = "absolute"; // Ensure the shape is absolutely positioned
  return shape;
}

// Function to constrain position within the viewport
function constrainPosition(x, y, shape) {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const shapeWidth = shape.offsetWidth;
  const shapeHeight = shape.offsetHeight;

  // Ensure the shape stays within the viewport
  const constrainedX = Math.max(60, Math.min(viewportWidth - shapeWidth - 60, x)); // Add buffer (5px)
  const constrainedY = Math.max(0, Math.min(viewportHeight - shapeHeight, y)); // Add buffer (5px)

  return { x: constrainedX, y: constrainedY };
}

if(!document.body.classList.contains('product-custom-bundle')){
  // Main hover and touch logic
  hoverTexts.forEach((text) => {
    let randomShape = null;

    const handleMouseMove = (e) => {
      if (!randomShape) return;

      const rect = text.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      // Adjust and constrain the shape's position
      const { x: constrainedX, y: constrainedY } = constrainPosition(
        mouseX - randomShape.offsetWidth / 2,
        mouseY - randomShape.offsetHeight / 2,
        randomShape
      );

      // Animate the shape to the constrained position
      gsap.to(randomShape, {
        x: constrainedX,
        y: constrainedY,
        duration: 0.2,
        ease: "power2.out",
      });
    };

    const handleTouchMove = (e) => {
      if (!randomShape) return;

      const touch = e.touches[0];
      const rect = text.getBoundingClientRect();
      const touchX = touch.clientX - rect.left;
      const touchY = touch.clientY - rect.top;

      // Adjust and constrain the shape's position
      const { x: constrainedX, y: constrainedY } = constrainPosition(
        touchX - randomShape.offsetWidth / 2,
        touchY - randomShape.offsetHeight / 2,
        randomShape
      );

      // Animate the shape to the constrained position
      gsap.to(randomShape, {
        x: constrainedX,
        y: constrainedY,
        duration: 0.2,
        ease: "power2.out",
      });
    };

    const createAndShowShape = (x, y) => {
      if (!randomShape) {
        randomShape = createRectShape(text.innerText);
        text.appendChild(randomShape);

        // Set initial position
        const rect = text.getBoundingClientRect();
        const initialX = x - randomShape.offsetWidth / 2;
        const initialY = y - randomShape.offsetHeight / 2;

        // Constrain the initial position
        const { x: constrainedX, y: constrainedY } = constrainPosition(
          initialX,
          initialY,
          randomShape
        );

        gsap.set(randomShape, {
          x: constrainedX,
          y: constrainedY,
          opacity: 0,
        });

        // Animate the appearance of the shape
        gsap.to(randomShape, {
          opacity: 1,
          scale: 2,
          duration: 0.3,
          ease: "power2.out",
        });
      }
    };

    const removeShape = () => {
      if (randomShape) {
        gsap.to(randomShape, {
          opacity: 0,
          scale: 0.5,
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            if (text.contains(randomShape)) {
              text.removeChild(randomShape);
              randomShape = null;
            }
          },
        });
      }
      text.removeEventListener("mousemove", handleMouseMove);
      text.removeEventListener("touchmove", handleTouchMove);
    };

    text.addEventListener("mouseenter", (e) => {
      const rect = text.getBoundingClientRect();
      createAndShowShape(e.clientX - rect.left, e.clientY - rect.top);
      text.addEventListener("mousemove", handleMouseMove);
    });

    text.addEventListener("mouseleave", removeShape);

    text.addEventListener("touchstart", (e) => {
      const touch = e.touches[0];
      const rect = text.getBoundingClientRect();
      createAndShowShape(touch.clientX - rect.left, touch.clientY - rect.top);
      text.addEventListener("touchmove", handleTouchMove);
    });

    text.addEventListener("touchend", removeShape);
  });
}







    // const hoverTexts = document.querySelectorAll('.hover-text');

    //     function createRectShape(text) {
    //         const shape = document.createElement('div');
    //         shape.classList.add('random-shape');
    //         shape.innerText = text;
    //         return shape;
    //     }

    //     function adjustShapePosition(shape, x, y, textElement, wrapper) {
    //         const wrapperRect = wrapper.getBoundingClientRect();
    //         const textRect = textElement.getBoundingClientRect();
    //         const shapeWidth = shape.offsetWidth;
    //         const shapeHeight = shape.offsetHeight;

    //         // Calculate available space around the text
    //         let adjustedX = x - shapeWidth / 2;
    //         let adjustedY = y - shapeHeight / 2;

    //         // Ensure the shape doesn't overflow the wrapper horizontally
    //         if (textRect.left + adjustedX < wrapperRect.left) {
    //             adjustedX = wrapperRect.left - textRect.left;
    //         } else if (textRect.left + adjustedX + shapeWidth > wrapperRect.right) {
    //             adjustedX = wrapperRect.right - textRect.left - shapeWidth;
    //         }

    //         // Ensure the shape doesn't overflow the wrapper vertically
    //         if (textRect.top + adjustedY < wrapperRect.top) {
    //             adjustedY = wrapperRect.top - textRect.top;
    //         } else if (textRect.top + adjustedY + shapeHeight > wrapperRect.bottom) {
    //             adjustedY = wrapperRect.bottom - textRect.top - shapeHeight;
    //         }

    //         gsap.set(shape, {
    //             x: adjustedX,
    //             y: adjustedY,
    //         });
    //     }

    //     hoverTexts.forEach(text => {
    //         let randomShape = null;
    //         const wrapper = document.querySelector('.wrapper');

    //         const handleMouseMove = (e) => {
    //             if (!randomShape) return;

    //             const rect = text.getBoundingClientRect();
    //             const x = e.clientX - rect.left;
    //             const y = e.clientY - rect.top;

    //             adjustShapePosition(randomShape, x, y, text, wrapper);
    //             gsap.to(randomShape, {
    //                 duration: 0.2,
    //                 ease: 'power2.out'
    //             });
    //         };

    //         text.addEventListener('mouseenter', () => {
    //             if (!randomShape) {
    //                 randomShape = createRectShape(text.innerText);
    //                 text.appendChild(randomShape);

    //                 gsap.to(randomShape, {
    //                     opacity: 1,
    //                     scale: 2,
    //                     duration: 0.2,
    //                     ease: 'power2.out',
    //                 });

    //                 adjustShapePosition(randomShape, 0, 0, text, wrapper);
    //                 text.addEventListener('mousemove', handleMouseMove);
    //             }
    //         });

    //         text.addEventListener('mouseleave', () => {
    //             if (randomShape) {
    //                 gsap.to(randomShape, {
    //                     opacity: 0,
    //                     scale: 0.5,
    //                     duration: 0.2,
    //                     ease: 'power2.out',
    //                     onComplete: () => {
    //                         if (text.contains(randomShape)) {
    //                             text.removeChild(randomShape);
    //                             randomShape = null;
    //                         }
    //                     },
    //                 });
    //             }
    //             text.removeEventListener('mousemove', handleMouseMove);
    //         });
    //     });

    //     window.addEventListener('resize', () => {
    //         hoverTexts.forEach(text => {
    //             if (text.querySelector('.random-shape')) {
    //                 const randomShape = text.querySelector('.random-shape');
    //                 const wrapper = document.querySelector('.wrapper');
    //                 adjustShapePosition(randomShape, 0, 0, text, wrapper);
    //             }
    //         });
    //     });


/***********Hover texts JS ends**********/


$('body').on('click', '[id^="Details-"] .summary-child', function(event) {
  var $summary = $(this);

  // Set attributes for accessibility
  $summary.attr("role", "button");
  // console.log('$summary',$summary)
  $summary.attr(
    "aria-expanded",
    $summary.parent().attr("open") ? "true" : "false"
  );

  if ($summary.next().attr("id")) {
    $summary.attr("aria-controls", $summary.next().attr("id"));
  }

  // Click event logic
  var $mainParent = $summary.parent();
  var $allAccordions = $(".accordion-main-details");
  var $filteredDetails = $allAccordions.not($mainParent);

  var $contentElement = $summary.siblings(".accordion__content");
  var $allSummary = $('.summary-child + .accordion__content').not($contentElement);

  // Remove active class from all other accordions
  $filteredDetails.removeClass("active-accordion");

  // Toggle active class on clicked accordion
  $mainParent.toggleClass("active-accordion");

  // Slide up all other accordion content
  $allSummary.slideUp();

  // Slide toggle the content of the clicked accordion
  $contentElement.slideToggle("fast");
});

// Optional: handling keyup escape event if needed
$('[id^="Details-"] .summary-child').on('keyup', function(event) {
  if (event.key === "Escape") {
    onKeyUpEscape(event);  // Ensure this function is defined
  }
});

// document.addEventListener('rebuy:smartcart.ready', (event) => {
//     const smartcart = event.detail.smartcart;
//     console.log('rebuy:smartcart.ready: smartcart', smartcart);
// });
if($('body').hasClass('template-collection')){
$(`.custom-filter-btn .list-menu__item input[type="checkbox"]`).on('change',function(){
    var parent = $(this).parents('.facets__label');
    parent.toggleClass('active')
    // if ($(this).prop('checked')) {
    //     // console.log('Checkbox is checked');
    // } else {
    //     // console.log('Checkbox is unchecked');
    // }
})
}

// Membership Perk Tabbing
$(document).ready( function(){
  $('body').on('click', '.members-benefits-tabs-holder .tab-button', function() {
    $('.members-benefits-tabs-holder .tab-button').removeClass('active-tab');
    $(this).addClass('active-tab');
    let id = $(this).data('redirect');
  
    let contentElement = $('.members__benefits__list #'+id)
    $('.tab-content-wrapper').removeClass('active-tab');
    contentElement.addClass('active-tab');
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

    if (urlParams.has("trigger_oos") == true) {
      var flag = urlParams.get("trigger_oos");
      if (flag == "true") {
        setTimeout(function () {
          document.querySelector(".custom-klaviyo-button").click();
        }, 4000);
      }
    }

  if(window.innerWidth > 768){
    document.getElementById('svg-container').addEventListener('mouseover', function() {
      this.parentElement.querySelector('.footer-shop-btn').classList.add('is-visible');
    });
  }
});

// MemberShip Pricing 
$('body').on('click', '.tier-box .tier-wrap .box', function() {
  $('.tier-box .tier-wrap .box').removeClass('active');
  $(this).addClass('active')
})
if($('body').hasClass('template-article') || $('body').hasClass('page-philanthropy')){
  AOS.init();
}

